import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
    const { googleSession } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(false);

    useEffect(() => {
        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            setError(true);
            return;
        }
        googleSession(sessionId)
            .then(() => {
                toast.success("Signed in with Google");
                navigate("/account", { replace: true });
            })
            .catch(() => {
                setError(true);
                toast.error("Google sign-in failed");
            });
    }, []);

    return (
        <div className="min-h-[50vh] flex items-center justify-center text-center">
            {error ? (
                <div>
                    <p className="font-serif text-2xl">Sign-in failed</p>
                    <button onClick={() => navigate("/login")} className="text-gold mt-4 hover:underline">Back to Login</button>
                </div>
            ) : (
                <p className="text-muted-foreground">Signing you in…</p>
            )}
        </div>
    );
}
